package com.milta.core.localization.translations.sq

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Historiku i itinerareve",
    periodLabel = "Periudha",
    periodLastEightDays = "8 ditët e fundit",
    periodSingleDate = "Datë specifike",
    periodRange = "Interval datash",
    rangeFromLabel = "Nga",
    rangeToLabel = "Deri më",
    driverFilterLabel = "Shoferi",
    driverFilterAllOption = "Të gjithë shoferët",
    columnDate = "Data",
    columnDriver = "Shoferi",
    columnTotalDeliveries = "Total dorëzimet",
    columnDelivered = "Dorëzuar",
    columnFailed = "Dështuar",
    viewProofsAction = "Shiko provat",
    emptyHistoryMessage = "Nuk u gjet asnjë itinerar për këtë periudhë.",
    errorInvalidPeriod = "Periudha e zgjedhur nuk është e vlefshme.",
    screenBTitle = "Historiku i provave të dorëzimit",
    routeOfLabel = "Itinerar i datës",
    totalDeliveriesLabel = "dorëzime",
    deliveredLabel = "dorëzuar",
    failedLabel = "dështuar",
    backToHistoryAction = "Historiku i itinerareve",
    statusDeliveredBadge = "Dorëzuar",
    statusFailedBadge = "Dështuar",
    viewReasonAction = "Shiko arsyen",
    hideReasonAction = "Fshih arsyen",
    photoPlaceholderAlt = "Nuk ka foto në dispozicion",
    photoAlt = "Provë dorëzimi",
    emptyProofsMessage = "Nuk ka prova dorëzimi në dispozicion për këtë itinerar.",
    paginationPrevious = "I mëparshëm",
    paginationNext = "Tjetër",
)
